let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dWOwD")).then(() => parcelRequire('dMJRY'));